exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-label[data-v-4017ce58]{font-size:14px;color:#606266;margin:10px 10px 10px 0;font-weight:bold}\n", ""]);

// exports
